namespace RioERP.Orders {
    export interface BrandAmbassadorPaymentsForm {
        BrandAmbassadorId: Serenity.IntegerEditor;
        PaymentDate: Serenity.DateEditor;
        PaidAmount: Serenity.DecimalEditor;
        PaymentMode: Serenity.EnumEditor;
        Remark: Serenity.StringEditor;
        PaymentRefNo: Serenity.StringEditor;
        BankName: Serenity.StringEditor;
        Comment: Serenity.StringEditor;
        ReceiptNo: Serenity.StringEditor;
    }

    export class BrandAmbassadorPaymentsForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.BrandAmbassadorPayments';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!BrandAmbassadorPaymentsForm.init)  {
                BrandAmbassadorPaymentsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DateEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.EnumEditor;
                var w4 = s.StringEditor;

                Q.initFormType(BrandAmbassadorPaymentsForm, [
                    'BrandAmbassadorId', w0,
                    'PaymentDate', w1,
                    'PaidAmount', w2,
                    'PaymentMode', w3,
                    'Remark', w4,
                    'PaymentRefNo', w4,
                    'BankName', w4,
                    'Comment', w4,
                    'ReceiptNo', w4
                ]);
            }
        }
    }
}
